











































import { Component, Vue } from 'nuxt-property-decorator'
import BlkCarousel from '~/components/BlkCarousel.vue'
import BlkSlide from '~/components/BlkSlide.vue'

interface FAQ {
  id: string
  subtitle: string
  title: string
  description1: string
  description2: string
  description3: string
  to?: string
  imageName: string
  altText: string
  anchorName: string
}

interface FAQMetadata {
  id: string
  to: string
  imageName: string
}

@Component({
  name: 'BlkHowDoesItWork',
  components: {
    BlkCarousel,
    BlkSlide
  }
})
export default class extends Vue {
  faqs: FAQ[] = []
  faqsMetadata: FAQMetadata[] = [
    { id: 'origination', to: '', imageName: 'origin' },
    { id: 'selection', to: '', imageName: 'selection' },
    { id: 'offer', to: '', imageName: 'available' },
    { id: 'profitability', to: '', imageName: 'profit' }
  ]
  created() {
    this.faqs = this.faqsMetadata.map((metadata) => {
      const baseI18nPath = `learnMore.howDoesItWork.faqs.${metadata.id}`
      return {
        id: metadata.id,
        subtitle: this.$tc(baseI18nPath + '.subtitle'),
        title: this.$tc(baseI18nPath + '.title'),
        description1: this.$tc(baseI18nPath + '.text1'),
        description2: this.$tc(baseI18nPath + '.text2'),
        description3: this.$tc(baseI18nPath + '.text3'),
        to: metadata.to,
        imageName: metadata.imageName,
        altText: this.$tc(baseI18nPath + '.altText'),
        anchorName: this.$tc(baseI18nPath + '.anchorName')
      }
    })
  }
}
